export const CAREER_URL = "career";
export const careerByIdUrl = (id) => `career/${id}`;
